import React, {useEffect, useState} from "react";
import {Button, Col, Divider, Form, Popconfirm, Row, Space, Spin, Typography} from "antd";
import {InputFields} from "../../../../../../../components/common";
import {LOAI_FORM, TT_PHIEU_VTYT, tabKeys} from "../../../../../../../types/enums";
import Icons from "../../../../../../../assets/icons";
import TableInputAdd
    from "../TableInputAdd/TableInputAdd";
import ModalCustom from "../../../../../../../components/common/ModalCustom/ModalCustom";
import ModalDeny from "../../../../../../Medicines/MedicalSuppliesStore/components/Detail/ModalDeny/ModalDeny";
import {
    columns as columnsInit,

} from "./config";
import {
    getPhongBanAPI, searchEmployeeAPI,

} from "../../../../../../../redux/reducer/employee";
import {useAppDispatch, useAppSelector} from "../../../../../../../redux/hooks";
import {employeeService} from "api"
import Notification from "../../../../../../../components/common/notification/notification";
import { count } from "console";
import { setLoading } from 'redux/reducer/medicineStore';
import { setActiveKey } from "redux/reducer/common";

const Tab1 =React.forwardRef((props: any, ref)  =>  {
    const {data, closeModal, type, getListApi, setCurrentPage} = props;
    const [loading, setLoading] = useState(false);
    const [count,setCount] = useState(0)
    const [form] = Form.useForm();
    const [columns, setColumns] = useState(columnsInit);
    const [datas, setData] = useState<any[]>([]);
    const [idKhoaDaoTao, setidKhoaDaoTao] = useState<any>(data.id);
    const employees = useAppSelector(
        (state) => state.employeesReducer
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (type == "Thêm") {
            form.resetFields();

        } else {
            getList(data.id);
        }
    }, [data]);
    const editApi = async () => {
        setLoading(true);
      
        try {
          // Check if datas already contains the idNhanVien
          let duplicate = false;
          for (let index = 0; index < datas.length; index++) {
            const element = datas[index];
            for (let j = 0; j < datas.length; j++) {
                const elementj = datas[j];
                if(element.idNhanVien === elementj.idNhanVien && index !==j)
                {
                    duplicate=true;
                    break;               
                }
              }
          }
          if(!duplicate) {
            const res = await employeeService
              .updateTraningNV(datas, data.id)
              .then((res) => {
                  Notification(
                    "success", 
                    "Đã chỉnh sửa thành công danh sách nhân viên tham gia đào tạo "
                  );
                 // dispatch(setActiveKey(tabKeys.TRAINING.LIST_TRAINNING));
              });
          } else {
            Notification(
              "error",
              "Không được thêm trùng nhân viên"  
            );
            setLoading(false);
            return;
          }
          
          ////////////////////////////
          setLoading(false);
           closeModal();
           await getListApi({});
        } catch (error) {
          setLoading(false);
          Notification(
            "error",
            "Đã có lỗi khi sửa danh sách nhân viên tham gia đào tạo"
          );
        }
      };
    // const editApi = async () => {
    //     setLoading(true);
    //     try {
    //         const res = await employeeService.updateTraningNV(datas,data.id).then(res => {
                
    //             Notification("success", "Đã chỉnh sửa thành công danh sách nhân viên tham gia đào tạo ");
    //         });
    //         setLoading(false);
    //         closeModal();
    //         await getListApi({});

    //     } catch (error) {
    //         setLoading(false);
    //         Notification("error", "Đã có lỗi khi sửa danh sách nhân viên tham gia đào tạo");

    //     }
    // };
    const addApi = async () => {
        setLoading(true);
        try {
            if ( data !==null ) {
                if (data.id === null || data.id === undefined){
                    Notification("warning", "Chưa có thông tin khóa đào tạo cần thêm và lưu khóa đào tạo");
                }
                // const res = await employeeService.updateTraningNV(datas).then(res => {
                //     Notification("success", "Đã thêm nhân viên vào khóa đào tạo thành công  ");
                // });
                setLoading(false);
                closeModal();
                await getListApi({});
            }else {
                Notification("warning", "Chưa có thông tin kháo đào tạo cần thêm và lưu khóa đào tạo");
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            Notification("error", "Đã có lỗi khi thêm nhân viên vào khóa đào tạo");

        }
    };
    const getList = async (id) => {
        setLoading(true);
        try {
            const response = await employeeService
                .getEmployeeTraning(id)
                .then(res => {

                    setData(res);
                });
            setLoading(false);
        } catch (error) {
            setLoading(false);
            
            Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên tham gia");
        }
    };
    const getListDaoTaoNew = async () => {
        setLoading(true);
        try {
            const response = await employeeService
                .getRecruitmentNew()
                .then(res => {

                    setData(res);
                });
            setLoading(false);
        } catch (error) {
            setLoading(false);
            
            Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên tham gia");
        }
    };
    const onFinish = values => {
        if (type == "Thêm") {
            addApi();
        } else {
            editApi();
        }
    };
    const handleModalClose = () => {
        dispatch(setActiveKey(tabKeys.TRAINING.LIST_TRAINNING));
        closeModal();
      // Explicitly set activeTab to LIST_TRAINING after closing the modal
    };
    return (
        <Spin spinning={loading}>
            <Form form={form} onFinish={onFinish}>
            <div className="detail-tab1-analysis">

                <div className="container">
                    <div className="container-main">
                        {datas && (
                            <TableInputAdd
                                // scroll={{x: 4000}}
                                setData={setData}
                                isCheckbox={undefined}
                                pagination={false}
                                // data={data.map((item, index) => ({
                                //   key: index,
                                //   ...item,
                                // }))}
                                data={[...datas]}
                                column={columns}
                                disabled={undefined}
                                count={count}
                                setCount={setCount}
                                id={idKhoaDaoTao}
                            ></TableInputAdd>
                        )}
                    </div>
                </div>
                <Row justify="end" style={{ marginTop: 12 }}>
                    <Col>
                        <Space>
                            <Button onClick={handleModalClose} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                            <Button htmlType="submit" type="primary">
                                Lưu lại
                            </Button>
                        </Space>{" "}
                    </Col>
                </Row>

            </div>
            </Form>
        </Spin>
    );
});
export default Tab1;
